import { Redirect, Route, Switch } from 'react-router-dom';
import DownloadLabel from './components/DownloadLabel/DownloadLabel';
import ItemsList from './components/ItemsList/ItemsList';
import OrderLookup from './components/OrderLookup/OrderLookup';
import { PageNotFound } from './components/PageNotFound';
import { ProtectedRoute } from './components/ProtectedRoute';
import Review from './components/Review/Review';
import { Shipping } from './components/Shipping/Shipping';
import Summary from './components/Summary/Summary';
import { useFirebase } from './firebase/context';
import { useLanguage } from './hooks/useLanguage';

const shopPathPrefix = '/:shop';

export const Routes = () => {
  const firebase = useFirebase();
  const { languageSettingsEnabled } = useLanguage();
  const defaultLanguage = firebase.publicConfig?.language;

  const activePrefix = firebase.hasCustomDomain() ? '' : shopPathPrefix;
  const languagePrefix = languageSettingsEnabled ? '/:lang([a-z]{2})' : '';

  return (
    <Switch>
      {languageSettingsEnabled && defaultLanguage && (
        <Route
          exact
          path={firebase.hasCustomDomain() ? '/' : shopPathPrefix}
          render={() => <Redirect to={firebase.getPathTo(`${defaultLanguage}`)} />}
        />
      )}
      <Route exact path={`${activePrefix}${languagePrefix}` || '/'} component={OrderLookup} />
      <ProtectedRoute
        exact
        path={`${activePrefix}${languagePrefix}/exchange`}
        component={ItemsList}
      />
      <ProtectedRoute
        exact
        path={`${activePrefix}${languagePrefix}/shipping`}
        component={Shipping}
      />
      <ProtectedRoute exact path={`${activePrefix}${languagePrefix}/review`} component={Review} />
      <ProtectedRoute exact path={`${activePrefix}${languagePrefix}/summary`} component={Summary} />
      <ProtectedRoute
        exact
        path={`${activePrefix}${languagePrefix}/download-label`}
        component={DownloadLabel}
      />
      <Route path="*" component={PageNotFound} />
    </Switch>
  );
};
